import React from 'react'
import { AlertIcon, Button, colors, DialogActions, DialogContent, DialogTitle } from '@diversioteam/diversio-ds'

import * as S from './closeSurveyDialog.styles'
import { CloseSurveyDialogProps } from './closeSurveyDialog.types'

export const CloseSurveyDialog = ({ open, numberOfRespondents, onClose, onConfirm }: CloseSurveyDialogProps) => {
    return (
        <S.Dialog open={open} onClose={onClose} hideBackdrop={false}>
            <DialogTitle>
                <S.IconWrapper>
                    <AlertIcon type="bold" color={colors.primaryWhite} />
                </S.IconWrapper>
                Participants will no longer be able to access this survey link. This action is final and cannot be
                undone.
            </DialogTitle>

            <DialogContent>
                You have collected {numberOfRespondents} responses so far. Click continue to generate results
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="secondaryLight" fullWidth>
                    Cancel
                </Button>

                <Button onClick={onConfirm} color="primary" fullWidth>
                    Close Survey & Continue
                </Button>
            </DialogActions>
        </S.Dialog>
    )
}
